import _ from 'lodash';
import Validator from 'validatorjs';
import React, { Component } from 'react';
import { Col, Row } from 'react-bootstrap';

import { FormControl } from '../../../../../facturotopia';
import TipoComprobante from '../../../support/enum/TipoComprobante';
import ComercioExteriorCatalogoManager from '../../../../catalogs/managers/ComercioExteriorCatalogoManager';
import CertificadoOrigenOptions  from '../../../support/catalogs/complementos/comercio-exterior/CertificadoOrigenOptions';

class ComercioExteriorBaseForm extends Component {
  state = {}

  constructor(props) {
    super(props);

    const { data = {} } = props;

    this.state = {
      data: {
        ...data,
      },
      isValid: false,
      isTransporteInternacional: false,
      validator: new Validator({}, this.rules({})),
    };
  }

  componentDidMount() {
    const Incoterm = ComercioExteriorCatalogoManager.get('c_ce_incoterm');
    const MotivoTraslado = ComercioExteriorCatalogoManager.get('c_ce_motivo_traslado');
    const ClavePedimento = ComercioExteriorCatalogoManager.get('c_ce_clave_pedimento');

    let catalogos = {};

    catalogos.Incoterm = this.getCatalogo(Incoterm, 'descripcion', 'incoterm');
    catalogos.MotivoTraslado = this.getCatalogo(MotivoTraslado, 'descripcion', 'motivo_traslado');
    catalogos.ClavePedimento = this.getCatalogo(ClavePedimento, 'descripcion', 'clave_pedimento');

    this.setState({
      catalogos
    });
  }

  getCatalogo = (values, label, value) => {
    if (!!values) {
      const sorted = _.sortBy(values.map((item) => {
        return {
          label: `${item[label]} (${item[value]})`,
          value: item[value]
        }
      }), 'label');

      return [
        {
          label: 'Selecciona',
          value: ''
        }
      ].concat(sorted);
    }
  }

  rules(data) {
    const isFungeCertificadoOrigen = this.isFungeCertificadoOrigen();
    const isComprobanteTraslados = this.isComprobanteTraslados();

    return {
      'MotivoTraslado': [isComprobanteTraslados ? 'required' : 'string', 'string'],
      'CertificadoOrigen': ['required', 'string'],
      'NumCertificadoOrigen': [isFungeCertificadoOrigen ? 'required' : 'string', 'string', 'min:6', 'max:40'],
      'NumeroExportadorConfiable': ['string', 'min:1', 'max:50'],
      'Incoterm': ['required', 'string'],
      'Observaciones': ['string', 'min:1', 'max:300'],
      'TipoCambioUSD': ['required', 'decimal:6'],
      'TotalUSD': ['required', 'decimal:6']
    }
  }

  handleOnChange = (value) => {
    const data = {
      ...this.state.data,
      ...value
    }

    const validator = this.validate(data);
    const isValid = validator.passes();
    const event = {
      isValid: isValid,
      name: 'base'
    }

    this.setState({
      data,
      isValid: isValid
    });

    this.props.onFormDataChange({
      ...this.props.data,
      ...data
    }, event);
  }

  validate(data) {
    const validator = new Validator(data, this.rules(data));

    validator.check();

    this.setState({
      validator
    });

    return validator;
  }

  isComprobanteTraslados = () => {
    const { input } = this.props;

    if (!!input) {
      return TipoComprobante.make(input.TipoDeComprobante).isTraslado();
    }

    return false;
  }

  isFungeCertificadoOrigen = () => {
    return this.state.data?.CertificadoOrigen === '1';
  }

  render() {
    const rules = this.rules();
    const { data = {}, catalogos = {} } = this.state;

    return (
      <div className="pb-4">
        <div className="section pt-2">
          <Row>
            <Col sm md={ 4 }>
              <FormControl type="select"
                label="Motivo Traslado"
                name="MotivoTraslado"
                placeholder=""
                help=""
                rules={ rules.MotivoTraslado }
                value={ data.MotivoTraslado }
                options={ catalogos.MotivoTraslado }
                onChange={ this.handleOnChange }
              />
            </Col>

            <Col sm md={ 4 }>
              <FormControl type="text"
                label="Tipo Operación"
                name="TipoOperacion"
                placeholder=""
                help=""
                rules={ rules.TipoOperacion }
                value="(2) Exportación"
                onChange={ this.handleOnChange }
                readOnly
              />
            </Col>

            <Col sm md={ 4 }>
              <FormControl type="text"
                label="Clave de Pedimento"
                name="ClaveDePedimento"
                placeholder=""
                help=""
                rules={ rules.ClaveDePedimento }
                value="(A1) IMPORTACION O EXPORTACION DEFINITIVA"
                onChange={ this.handleOnChange }
                readOnly
              />
            </Col>

            <Col sm md={ 4 }>
              <FormControl type="select"
                label="Certificado Origen"
                name="CertificadoOrigen"
                placeholder=""
                help=""
                minLength="6"
                maxLength="40"
                rules={ rules.CertificadoOrigen }
                value={ data.CertificadoOrigen }
                options={ CertificadoOrigenOptions }
                onChange={ this.handleOnChange }
              />
            </Col>

            <Col sm md={ 4 }>
              <FormControl type="text"
                label="Número Certificado Origen"
                name="NumCertificadoOrigen"
                placeholder=""
                help=""
                minLength="6"
                maxLength="40"
                rules={ rules.NumCertificadoOrigen }
                value={ data.NumCertificadoOrigen }
                onChange={ this.handleOnChange }
              />
            </Col>

            <Col sm md={ 4 }>
              <FormControl type="text"
                label="Número Exportador Confiable"
                name="NumeroExportadorConfiable"
                placeholder=""
                help=""
                minLength="1"
                maxLength="50"
                rules={ rules.NumeroExportadorConfiable }
                value={ data.NumeroExportadorConfiable }
                onChange={ this.handleOnChange }
              />
            </Col>

            <Col sm md={ 4 }>
              <FormControl type="select"
                label="Incoterm"
                name="Incoterm"
                placeholder=""
                help=""
                rules={ rules.Incoterm }
                value={ data.Incoterm }
                options={ catalogos.Incoterm }
                onChange={ this.handleOnChange }
              />
            </Col>

            <Col sm md={ 4 }>
              <FormControl type="number"
                label="Tipo Cambio USD"
                name="TipoCambioUSD"
                placeholder=""
                help=""
                rules={ rules.TipoCambioUSD }
                value={ data.TipoCambioUSD }
                onChange={ this.handleOnChange }
              />
            </Col>

            <Col sm md={ 4 }>
              <FormControl type="number"
                label="Total USD"
                name="TotalUSD"
                placeholder=""
                help=""
                rules={ rules.TotalUSD }
                value={ data.TotalUSD }
                onChange={ this.handleOnChange }
              />
            </Col>

            <Col sm md={ 12 }>
              <FormControl as="textarea"
                label="Observaciones"
                name="Observaciones"
                placeholder=""
                help=""
                minLength="1"
                maxLength="300"
                rules={ rules.Observaciones }
                value={ data.Observaciones }
                onChange={ this.handleOnChange }
              />
            </Col>
          </Row>
        </div>
      </div>
    )
  }
}

export default ComercioExteriorBaseForm;